import CriteriaSetupAPI from '@/api/CriteriaSetupAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';

export default {
	/**
	 * Lấy thông tin thiết lập
	 */
	loadCriteriaSetup: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: CriteriaSetupAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				params: payload
			},
			true
		);

		if (!res || !res.Success || !res.Data || res.Data.length <= 0) return null;
		context.commit('updateCriteriaSetups', res.Data);
		return res.Data;
	},

	saveCriteriaSetup: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: `${CriteriaSetupAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/save`,
				data: payload
			},
			true
		);

		if (!res || !res.Success || !res.Data) return false;
		context.commit('updateCriteriaSetups', payload.criteriaSetups);
		return res.Success;
	},

	getCriteriaDefault: async function(context) {
		let res = await httpClient.getAsync(
			{
				url: `${CriteriaSetupAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/default`
			},
			true
		);

		if (!res || !res.Success || !res.Data || res.Data.length <= 0) return null;
		context.commit('updateCriteriaSetups', res.Data);
		return res.Data;
	}
};
